import React from "react";
import Layout from "src/components/Layout";

const NotFound: React.FC = () => {
  return (
    <Layout>
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
      </div>
    </Layout>
  );
};

export default NotFound;
